import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { FileReaderModule, BrowserCapabilitiesService } from '@classifieds-sell/shared';
import {
    TgBoxes2Module,
    TgButtons2Module,
    TgDragModule,
    TgDropGridModule,
    TgFileUploaderModule,
    TgFormsModule,
    TgGridModule,
    TgIconBasicInfoFramedModule,
    TgIconBasicTickModule,
    TgIconBasicWarningFramedModule,
    TgIconBinModule,
    TgIconEditCropModule,
    TgIconEditRotateModule,
    TgIconStarFillModule,
    TgIconStarModule,
    TgIconUploadModule,
    TgImagesModule,
    TgImageViewer2Module,
    TgLists2Module,
    TgModalModule,
    TgRackModule,
    TgValidationModule
} from '@trademe/tangram';
import { PhotoCardModule } from '../photo-card/photo-card.module';
import { PhotoEditorModule } from '../photo-editor/photo-editor.module';
import { PhotoPickerModule } from '../photo-picker/photo-picker.module';
import { PhotoManagementComponent } from './photo-management.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        TgBoxes2Module,
        TgButtons2Module,
        TgFormsModule,
        TgGridModule,
        TgIconBasicTickModule,
        TgIconBasicWarningFramedModule,
        TgIconBinModule,
        TgIconUploadModule,
        TgIconEditCropModule,
        TgIconEditRotateModule,
        TgIconStarModule,
        TgIconStarFillModule,
        TgImagesModule,
        TgImageViewer2Module,
        TgModalModule,
        TgRackModule,
        TgValidationModule,
        PhotoCardModule,
        PhotoEditorModule,
        PhotoPickerModule,
        TgFileUploaderModule,
        TgBoxes2Module,
        TgIconBasicInfoFramedModule,
        TgDragModule,
        TgDropGridModule,
        TgLists2Module,
        FileReaderModule
    ],
    declarations: [PhotoManagementComponent],
    providers: [NgForm, BrowserCapabilitiesService],
    exports: [PhotoManagementComponent]
})
export class PhotoManagementModule {}
